@if(error) {
  <div class="alert alert-danger">{{ error }}</div>
}

<h1 data-automation-name="groupEditor">
  @switch(editing) {
    @case(true) {
      <span>Edit Group {{group_id}}</span>
    }
    @case(false) {
      <span>Register a new Group</span>
    }
  }
</h1>

<form name="groupForm" class="form-horizontal" [formGroup]="groupForm">
  <div class="form-group">
    <label for="groupId"> Group id: </label>
    <input id="groupId" class="form-control" name="group_id" type="text" formControlName="id" required>
    @if(groupForm.get('id')?.invalid && (groupForm.get('id')?.dirty || groupForm.get('id')?.touched)) {
      <div class="text-danger">
        <div *ngIf="groupForm.get('id')?.errors?.['required']">Group ID is required.</div>
      </div>
    }
  </div>
  <div class="form-group">
    <label for="division"> Portfolio id: </label>
    <input id="division" class="form-control" name="division" type="text" formControlName="division" required>
    @if(groupForm.get('division')?.invalid && (groupForm.get('division')?.dirty || groupForm.get('division')?.touched)) {
      <div class="text-danger">
        <div *ngIf="groupForm.get('division')?.errors?.['required']">Portfolio ID is required.</div>
      </div>
    }
  </div>
  <div class="form-group">
    <label for="label"> Label (optional): </label>
    <input id="label" class="form-control" name="label" type="text" formControlName="label">
  </div>

  <button id="save" class="btn btn-primary" type="button" (click)="save()" [disabled]="groupForm.invalid">Save</button>
  <a class="btn" (click)="backPage('/groups', router)">Cancel</a>
</form>
